<div>Page not found {$location}</div>

<script>
  import { location } from "svelte-spa-router";
</script>
